import { FC } from "react";

import { useRootContext } from "@client/context/RootContext";
import { DashboardPage, Help, OrdersHistory } from "@client/pages";
import { StatsDashboard } from "@client/pages/stats-dashboard/stats-dashboard";

/**
 * Basic route type that the router consumes for dynamic generation
 */
type Route = {
	path: string;
	component: FC;
};

/**
 * Define your routes here
 */
export const routes: () => Route[] = () => {
	const {
		layoutStore: { isDashboardActive },
	} = useRootContext();

	const routesList: Route[] = [
		{
			path: "/",
			component: DashboardPage,
		},
		{
			path: "/orders-history",
			component: OrdersHistory,
		},
		{
			path: "/help",
			component: Help,
		},
	];

	if (isDashboardActive)
		routesList.push(
			{
				path: "/dashboard",
				component: StatsDashboard,
			},
			{
				path: "/stats-dashboard", // this is reserverd for standalone dashboard mode
				component: StatsDashboard,
			}
		);
	return routesList;
};
